import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";

enum ProfileServiceEnum {
  save = "",
  getById = "/",
  getProfile = ""
}

export default class ProfileService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/profile");
  }

  public save = async (data): Promise<any> => await this.POST(ProfileServiceEnum.save, data);
  public getById = async (id): Promise<any> => await this.GET(ProfileServiceEnum.getById + id);
  public getProfile = async (): Promise<any> => await this.GET(ProfileServiceEnum.getProfile);
}
